import { PropsWithChildren, ReactNode } from "react";

export default function Tooltip({
  children,
  tooltipContent,
  position = "top",
}: PropsWithChildren<{
  tooltipContent: ReactNode;
  position?: "top" | "bottom" | "top-center" | "bottom-center";
}>) {
  let positionClasses =
    position === "top"
      ? "bottom-full -translate-y-1"
      : "top-full translate-y-1";

  if (position.endsWith("-center")) {
    positionClasses += " -translate-x-1/2";
  }

  return (
    <div className="relative group">
      {children}
      <div
        className={`absolute px-2 py-1 text-xs hidden group-hover:block bg-black text-nowrap border rounded-md border-[#2C2C30] ${positionClasses}`}
      >
        {tooltipContent}
      </div>
    </div>
  );
}
